module.exports = __webpack_public_path__ + "assets/img/ma-logo-fc2f50c4.png";